module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[99]220.a822f53.woff2";